virtual task receive({{ sequenceItemHandle.type }} {{ sequenceItemHandle.identifier }});
  store_transaction_without_id({{ sequenceItemHandle.identifier }});
  wait ({{ sequenceItemHandle.identifier }}.{{ sequenceItemHandle.klass.lastVariable.identifier }} === 1'b1);
  drop_transaction({{ sequenceItemHandle.identifier }});
endtask
